import { ListLoader, ItemLoader } from "@/loaders";

export default {
  list: new ListLoader("/school-campuses/", {
    setter: "campus/setCampuses",
  }),
  item: new ItemLoader("/school-campuses/", {
    setter: "campus/updateCampus",
  }),
};
